import { ErrorMessage, Field, FormikErrors, FormikValues } from "formik";
import { DatePicker } from "rsuite";
import "rsuite/DateRangePicker/styles/index.css";
import { SelfDocuments } from "../../../../components/Enums";

interface MyDocumentsFieldsProps {
  documentList: any;
  myDocumentList: any;
  isShowMyDocumentButton: any;
  setIsShowMyDocumentButton: any;
  values: any;
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean
  ) => Promise<void | FormikErrors<FormikValues>>;
  handleChange: (e: React.ChangeEvent<any>) => void;
}

const MyDocumentsFields: React.FC<MyDocumentsFieldsProps> = ({
  documentList,
  myDocumentList,
  isShowMyDocumentButton,
  setIsShowMyDocumentButton,
  values,
  handleChange,
  setFieldValue,
}) => {
  const inputFieldsDocuments = [
    SelfDocuments.PHYTOSANITARY_CERTIFICATE,
    SelfDocuments.HEALTH_AND_QUALITY_CERTIFICATE,
    SelfDocuments.PRIOR_NOTICE,
    SelfDocuments.FORM_AI,
    SelfDocuments.FUMIGATION_CERTIFICATE,
    SelfDocuments.ANNEXURE_C,
    SelfDocuments.BILL_OF_LADING,
    SelfDocuments.COMMERCIAL_INVOICE,
  ];

  const parseDateOrNull = (date?: string) => {
    if (!date) return null;
    const parsed = new Date(date);
    return isNaN(parsed.getTime()) ? null : parsed;
  };

  const selectedDocumentList = myDocumentList.filter((document: any) =>
    values.my_documents.some(
      (selectedDocumentId: string) => selectedDocumentId === document.id
    )
  );

  return (
    <>
      <div className="card my-card">
        <div className="card-header my-card-header bg-lighter d-flex justify-content-between">
          <div>
            <h6 className="my-card-header-head">My Documents (Self)</h6>
          </div>
          {isShowMyDocumentButton && (
            <div>
              <button
                title="Add My Documents"
                className="btn btn-sm btn-primary waves-effect waves-light p-0"
                type="button"
                style={{ margin: "5px" }}
                onClick={() => {
                  setIsShowMyDocumentButton(false);
                }}
              >
                <span>
                  <i className="ti ti-plus my-card-icon-button"></i>
                </span>
              </button>
            </div>
          )}
        </div>
        {!isShowMyDocumentButton && (
          <div className="card-body my-card-body">
            <div className="row g-3 m-0">
              <div className="col-12 col-sm-12 col-lg-12">
                <div
                  role="group"
                  aria-labelledby="checkbox-group"
                  className="row pt-3 m-0"
                  style={{
                    border: "1px solid #d1d0d4",
                    borderRadius: "0.375rem",
                  }}
                >
                  {myDocumentList.map((document: any) => (
                    <div key={document.id} className="col-12 col-sm-6 col-md-4">
                      <div className="form-check mb-3">
                        <Field
                          type="checkbox"
                          name="my_documents"
                          value={document.id.toString()}
                          className="form-check-input"
                          id={`permission-${document.id}`}
                        />
                        <label
                          htmlFor={`permission-${document.id}`}
                          className="form-check-label"
                        >
                          {document.name}
                        </label>
                      </div>
                    </div>
                  ))}
                </div>
                <ErrorMessage
                  name="my_documents"
                  className="text-danger"
                  component="div"
                />
              </div>
            </div>
            {myDocumentList.length > 0 &&
              selectedDocumentList.length > 0 &&
              selectedDocumentList.map((document: any) => {
                return (
                  inputFieldsDocuments.includes(document?.slug) && (
                    <div
                      className="sales_section_card"
                      style={{ paddingLeft: "0px", paddingRight: "0px" }}
                    >
                      <div className="bg-lighter d-flex justify-content-between">
                        <div>
                          <h6 className="my-card-header-head">
                            {document.name}
                          </h6>
                        </div>
                      </div>
                      <div className="px-1">
                        {document.slug ===
                          SelfDocuments.PHYTOSANITARY_CERTIFICATE && (
                          <div className="row g-3 m-0">
                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                              <label
                                htmlFor={`my_documents_inputs.${SelfDocuments.PHYTOSANITARY_CERTIFICATE}.psc_no`}
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Psc No.
                              </label>
                              <Field
                                name={`my_documents_inputs.${SelfDocuments.PHYTOSANITARY_CERTIFICATE}.psc_no`}
                                type="text"
                                className="form-control"
                                placeholder="Enter Psc No"
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name={`my_documents_inputs.${SelfDocuments.PHYTOSANITARY_CERTIFICATE}.psc_no`}
                                component="div"
                                className="text-danger"
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                              <label
                                htmlFor={`my_documents_inputs.${SelfDocuments.PHYTOSANITARY_CERTIFICATE}.registration_no`}
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Registration No.
                              </label>
                              <Field
                                name={`my_documents_inputs.${SelfDocuments.PHYTOSANITARY_CERTIFICATE}.registration_no`}
                                type="text"
                                className="form-control"
                                placeholder="Enter Registration No"
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name={`my_documents_inputs.${SelfDocuments.PHYTOSANITARY_CERTIFICATE}.registration_no`}
                                component="div"
                                className="text-danger"
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                              <label
                                htmlFor={`my_documents_inputs.${SelfDocuments.PHYTOSANITARY_CERTIFICATE}.date_of_treatment`}
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Date Of Treatment
                              </label>
                              <DatePicker
                                id={`my_documents_inputs.${SelfDocuments.PHYTOSANITARY_CERTIFICATE}.date_of_treatment`}
                                name={`my_documents_inputs.${SelfDocuments.PHYTOSANITARY_CERTIFICATE}.date_of_treatment`}
                                format="dd-MM-yyyy"
                                className="form-control"
                                placeholder="Select Date Of Treatment"
                                value={parseDateOrNull(
                                  values?.my_documents_inputs?.[
                                    SelfDocuments.PHYTOSANITARY_CERTIFICATE
                                  ]?.date_of_treatment
                                )}
                                onChange={(value: any) => {
                                  setFieldValue(
                                    `my_documents_inputs.${SelfDocuments.PHYTOSANITARY_CERTIFICATE}.date_of_treatment`,
                                    value || null
                                  );
                                }}
                                onSelect={(value) => {
                                  setFieldValue(
                                    `my_documents_inputs.${SelfDocuments.PHYTOSANITARY_CERTIFICATE}.date_of_treatment`,
                                    value || null
                                  );
                                }}
                              />
                              <ErrorMessage
                                name={`my_documents_inputs.${SelfDocuments.PHYTOSANITARY_CERTIFICATE}.date_of_treatment`}
                                component="div"
                                className="text-danger"
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                              <label
                                htmlFor={`my_documents_inputs.${SelfDocuments.PHYTOSANITARY_CERTIFICATE}.treatment`}
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Treatment
                              </label>
                              <Field
                                name={`my_documents_inputs.${SelfDocuments.PHYTOSANITARY_CERTIFICATE}.treatment`}
                                type="text"
                                className="form-control"
                                placeholder="Treatment"
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name={`my_documents_inputs.${SelfDocuments.PHYTOSANITARY_CERTIFICATE}.treatment`}
                                component="div"
                                className="text-danger"
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                              <label
                                htmlFor={`my_documents_inputs.${SelfDocuments.PHYTOSANITARY_CERTIFICATE}.chemical`}
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Chemical
                              </label>
                              <Field
                                name={`my_documents_inputs.${SelfDocuments.PHYTOSANITARY_CERTIFICATE}.chemical`}
                                type="text"
                                className="form-control"
                                placeholder="Chemical"
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name={`my_documents_inputs.${SelfDocuments.PHYTOSANITARY_CERTIFICATE}.chemical`}
                                component="div"
                                className="text-danger"
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                              <label
                                htmlFor={`my_documents_inputs.${SelfDocuments.PHYTOSANITARY_CERTIFICATE}.duration`}
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Duration
                              </label>
                              <Field
                                name={`my_documents_inputs.${SelfDocuments.PHYTOSANITARY_CERTIFICATE}.duration`}
                                type="text"
                                className="form-control"
                                placeholder="Duration"
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name={`my_documents_inputs.${SelfDocuments.PHYTOSANITARY_CERTIFICATE}.duration`}
                                component="div"
                                className="text-danger"
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                              <label
                                htmlFor={`my_documents_inputs.${SelfDocuments.PHYTOSANITARY_CERTIFICATE}.temperature`}
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Temperature
                              </label>
                              <Field
                                name={`my_documents_inputs.${SelfDocuments.PHYTOSANITARY_CERTIFICATE}.temperature`}
                                type="text"
                                className="form-control"
                                placeholder="Temperature"
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name={`my_documents_inputs.${SelfDocuments.PHYTOSANITARY_CERTIFICATE}.temperature`}
                                component="div"
                                className="text-danger"
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                              <label
                                htmlFor={`my_documents_inputs.${SelfDocuments.PHYTOSANITARY_CERTIFICATE}.concentration`}
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Concentration
                              </label>
                              <Field
                                name={`my_documents_inputs.${SelfDocuments.PHYTOSANITARY_CERTIFICATE}.concentration`}
                                type="text"
                                className="form-control"
                                placeholder="Concentration"
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name={`my_documents_inputs.${SelfDocuments.PHYTOSANITARY_CERTIFICATE}.concentration`}
                                component="div"
                                className="text-danger"
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                              <label
                                htmlFor={`my_documents_inputs.${SelfDocuments.PHYTOSANITARY_CERTIFICATE}.additional_information`}
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Additional Information
                              </label>
                              <Field
                                name={`my_documents_inputs.${SelfDocuments.PHYTOSANITARY_CERTIFICATE}.additional_information`}
                                type="text"
                                className="form-control"
                                placeholder="Additional Information"
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name={`my_documents_inputs.${SelfDocuments.PHYTOSANITARY_CERTIFICATE}.additional_information`}
                                component="div"
                                className="text-danger"
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                              <label
                                htmlFor={`my_documents_inputs.${SelfDocuments.PHYTOSANITARY_CERTIFICATE}.date_of_issue`}
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Date Of Issue
                              </label>
                              <DatePicker
                                id={`my_documents_inputs.${SelfDocuments.PHYTOSANITARY_CERTIFICATE}.date_of_issue`}
                                name={`my_documents_inputs.${SelfDocuments.PHYTOSANITARY_CERTIFICATE}.date_of_issue`}
                                format="dd-MM-yyyy"
                                className="form-control"
                                placeholder="Select Date of issue"
                                value={parseDateOrNull(
                                  values?.my_documents_inputs?.[
                                    SelfDocuments.PHYTOSANITARY_CERTIFICATE
                                  ]?.date_of_issue
                                )}
                                onChange={(value: any) => {
                                  setFieldValue(
                                    `my_documents_inputs.${SelfDocuments.PHYTOSANITARY_CERTIFICATE}.date_of_issue`,
                                    value
                                  );
                                }}
                                onSelect={(value) => {
                                  setFieldValue(
                                    `my_documents_inputs.${SelfDocuments.PHYTOSANITARY_CERTIFICATE}.date_of_issue`,
                                    value
                                  );
                                }}
                              />
                              <ErrorMessage
                                name={`my_documents_inputs.${SelfDocuments.PHYTOSANITARY_CERTIFICATE}.date_of_issue`}
                                component="div"
                                className="text-danger"
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                              <label
                                htmlFor={`my_documents_inputs.${SelfDocuments.PHYTOSANITARY_CERTIFICATE}.place_of_issue`}
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Place Of Issue
                              </label>
                              <Field
                                name={`my_documents_inputs.${SelfDocuments.PHYTOSANITARY_CERTIFICATE}.place_of_issue`}
                                type="text"
                                className="form-control"
                                placeholder="Enter Place of issue"
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name={`my_documents_inputs.${SelfDocuments.PHYTOSANITARY_CERTIFICATE}.place_of_issue`}
                                component="div"
                                className="text-danger"
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                              <label
                                htmlFor={`my_documents_inputs.${SelfDocuments.PHYTOSANITARY_CERTIFICATE}.code_no`}
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Code No.
                              </label>
                              <Field
                                name={`my_documents_inputs.${SelfDocuments.PHYTOSANITARY_CERTIFICATE}.code_no`}
                                type="text"
                                className="form-control"
                                placeholder="Enter Code No."
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name={`my_documents_inputs.${SelfDocuments.PHYTOSANITARY_CERTIFICATE}.code_no`}
                                component="div"
                                className="text-danger"
                              />
                            </div>
                          </div>
                        )}

                        {document.slug ===
                          SelfDocuments.HEALTH_AND_QUALITY_CERTIFICATE && (
                          <div className="row g-3 m-0">
                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                              <label
                                htmlFor={`my_documents_inputs.${SelfDocuments.HEALTH_AND_QUALITY_CERTIFICATE}.lab_name`}
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Lab Name
                              </label>
                              <Field
                                name={`my_documents_inputs.${SelfDocuments.HEALTH_AND_QUALITY_CERTIFICATE}.lab_name`}
                                type="text"
                                className="form-control"
                                placeholder="Enter Lab Name"
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name={`my_documents_inputs.${SelfDocuments.HEALTH_AND_QUALITY_CERTIFICATE}.lab_name`}
                                component="div"
                                className="text-danger"
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                              <label
                                htmlFor={`my_documents_inputs.${SelfDocuments.HEALTH_AND_QUALITY_CERTIFICATE}.certificate_no`}
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Certificate No.
                              </label>
                              <Field
                                name={`my_documents_inputs.${SelfDocuments.HEALTH_AND_QUALITY_CERTIFICATE}.certificate_no`}
                                type="text"
                                className="form-control"
                                placeholder="Enter Certificate No."
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name={`my_documents_inputs.${SelfDocuments.HEALTH_AND_QUALITY_CERTIFICATE}.certificate_no`}
                                component="div"
                                className="text-danger"
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                              <label
                                htmlFor={`my_documents_inputs.${SelfDocuments.HEALTH_AND_QUALITY_CERTIFICATE}.certificate_date`}
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Certificate Date
                              </label>
                              <DatePicker
                                id={`my_documents_inputs.${SelfDocuments.HEALTH_AND_QUALITY_CERTIFICATE}.certificate_date`}
                                name={`my_documents_inputs.${SelfDocuments.HEALTH_AND_QUALITY_CERTIFICATE}.certificate_date`}
                                format="dd-MM-yyyy"
                                className="form-control"
                                placeholder="Select Certificate Date"
                                value={parseDateOrNull(
                                  values?.my_documents_inputs?.[
                                    SelfDocuments.HEALTH_AND_QUALITY_CERTIFICATE
                                  ]?.certificate_date
                                )}
                                onChange={(value: any) => {
                                  setFieldValue(
                                    `my_documents_inputs.${SelfDocuments.HEALTH_AND_QUALITY_CERTIFICATE}.certificate_date`,
                                    value || null
                                  );
                                }}
                                onSelect={(value) => {
                                  setFieldValue(
                                    `my_documents_inputs.${SelfDocuments.HEALTH_AND_QUALITY_CERTIFICATE}.certificate_date`,
                                    value || null
                                  );
                                }}
                              />
                              <ErrorMessage
                                name={`my_documents_inputs.${SelfDocuments.HEALTH_AND_QUALITY_CERTIFICATE}.certificate_date`}
                                component="div"
                                className="text-danger"
                              />
                            </div>
                          </div>
                        )}

                        {document.slug === SelfDocuments.PRIOR_NOTICE && (
                          <div className="row g-3 m-0">
                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                              <label
                                htmlFor={`my_documents_inputs.${SelfDocuments.PRIOR_NOTICE}.main_reference_no`}
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Main Reference No.
                              </label>
                              <Field
                                name={`my_documents_inputs.${SelfDocuments.PRIOR_NOTICE}.main_reference_no`}
                                type="text"
                                className="form-control"
                                placeholder="Enter Main Reference No."
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name={`my_documents_inputs.${SelfDocuments.PRIOR_NOTICE}.main_reference_no`}
                                component="div"
                                className="text-danger"
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                              <label
                                htmlFor={`my_documents_inputs.${SelfDocuments.PRIOR_NOTICE}.certificate_reference_no`}
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Certificate Reference No.
                              </label>
                              <Field
                                name={`my_documents_inputs.${SelfDocuments.PRIOR_NOTICE}.certificate_reference_no`}
                                type="text"
                                className="form-control"
                                placeholder="Enter Certificate Reference No."
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name={`my_documents_inputs.${SelfDocuments.PRIOR_NOTICE}.certificate_reference_no`}
                                component="div"
                                className="text-danger"
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                              <label
                                htmlFor={`my_documents_inputs.${SelfDocuments.PRIOR_NOTICE}.certificate_issue_date`}
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Certificate Issue Date
                              </label>
                              <DatePicker
                                id={`my_documents_inputs.${SelfDocuments.PRIOR_NOTICE}.certificate_issue_date`}
                                name={`my_documents_inputs.${SelfDocuments.PRIOR_NOTICE}.certificate_issue_date`}
                                format="dd-MM-yyyy"
                                className="form-control"
                                placeholder="Select Certificate Issue Date"
                                value={parseDateOrNull(
                                  values?.my_documents_inputs?.[
                                    SelfDocuments.PRIOR_NOTICE
                                  ]?.certificate_issue_date
                                )}
                                onChange={(value: any) => {
                                  setFieldValue(
                                    `my_documents_inputs.${SelfDocuments.PRIOR_NOTICE}.certificate_issue_date`,
                                    value
                                  );
                                }}
                                onSelect={(value) => {
                                  setFieldValue(
                                    `my_documents_inputs.${SelfDocuments.PRIOR_NOTICE}.certificate_issue_date`,
                                    value
                                  );
                                }}
                              />
                              <ErrorMessage
                                name={`my_documents_inputs.${SelfDocuments.PRIOR_NOTICE}.certificate_issue_date`}
                                component="div"
                                className="text-danger"
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                              <label
                                htmlFor={`my_documents_inputs.${SelfDocuments.PRIOR_NOTICE}.nfsca_body`}
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                NFSCA Body
                              </label>
                              <Field
                                name={`my_documents_inputs.${SelfDocuments.PRIOR_NOTICE}.nfsca_body`}
                                type="text"
                                className="form-control"
                                placeholder="Enter NFSCA Body"
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name={`my_documents_inputs.${SelfDocuments.PRIOR_NOTICE}.nfsca_body`}
                                component="div"
                                className="text-danger"
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                              <label
                                htmlFor={`my_documents_inputs.${SelfDocuments.PRIOR_NOTICE}.reference_no`}
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Reference No.
                              </label>
                              <Field
                                name={`my_documents_inputs.${SelfDocuments.PRIOR_NOTICE}.reference_no`}
                                type="text"
                                className="form-control"
                                placeholder="Enter Reference No."
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name={`my_documents_inputs.${SelfDocuments.PRIOR_NOTICE}.reference_no`}
                                component="div"
                                className="text-danger"
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                              <label
                                htmlFor={`my_documents_inputs.${SelfDocuments.PRIOR_NOTICE}.place_of_issue`}
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Place Of Issue
                              </label>
                              <Field
                                name={`my_documents_inputs.${SelfDocuments.PRIOR_NOTICE}.place_of_issue`}
                                type="text"
                                className="form-control"
                                placeholder="Enter Place Of Issue"
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name={`my_documents_inputs.${SelfDocuments.PRIOR_NOTICE}.place_of_issue`}
                                component="div"
                                className="text-danger"
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                              <label
                                htmlFor={`my_documents_inputs.${SelfDocuments.PRIOR_NOTICE}.date_of_issue`}
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Date Of Issue
                              </label>
                              <DatePicker
                                id={`my_documents_inputs.${SelfDocuments.PRIOR_NOTICE}.date_of_issue`}
                                name={`my_documents_inputs.${SelfDocuments.PRIOR_NOTICE}.date_of_issue`}
                                format="dd-MM-yyyy"
                                className="form-control"
                                placeholder="Select Date Of Issue"
                                value={parseDateOrNull(
                                  values?.my_documents_inputs?.[
                                    SelfDocuments.PRIOR_NOTICE
                                  ]?.date_of_issue
                                )}
                                onChange={(value: any) => {
                                  setFieldValue(
                                    `my_documents_inputs.${SelfDocuments.PRIOR_NOTICE}.date_of_issue`,
                                    value
                                  );
                                }}
                                onSelect={(value) => {
                                  setFieldValue(
                                    `my_documents_inputs.${SelfDocuments.PRIOR_NOTICE}.date_of_issue`,
                                    value
                                  );
                                }}
                              />
                              <ErrorMessage
                                name={`my_documents_inputs.${SelfDocuments.PRIOR_NOTICE}.date_of_issue`}
                                component="div"
                                className="text-danger"
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                              <label
                                htmlFor={`my_documents_inputs.${SelfDocuments.PRIOR_NOTICE}.place_of_applicant`}
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Place Of Applicant
                              </label>
                              <Field
                                name={`my_documents_inputs.${SelfDocuments.PRIOR_NOTICE}.place_of_applicant`}
                                type="text"
                                className="form-control"
                                placeholder="Enter Place Of Applicant"
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name={`my_documents_inputs.${SelfDocuments.PRIOR_NOTICE}.place_of_applicant`}
                                component="div"
                                className="text-danger"
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                              <label
                                htmlFor={`my_documents_inputs.${SelfDocuments.PRIOR_NOTICE}.date_of_applicant`}
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Date Of Applicant
                              </label>
                              <DatePicker
                                id={`my_documents_inputs.${SelfDocuments.PRIOR_NOTICE}.date_of_applicant`}
                                name={`my_documents_inputs.${SelfDocuments.PRIOR_NOTICE}.date_of_applicant`}
                                format="dd-MM-yyyy"
                                className="form-control"
                                placeholder="Select Date Of Applicant"
                                value={parseDateOrNull(
                                  values.my_documents_inputs?.[
                                    SelfDocuments.PRIOR_NOTICE
                                  ]?.date_of_applicant
                                )}
                                onChange={(value: any) => {
                                  setFieldValue(
                                    `my_documents_inputs.${SelfDocuments.PRIOR_NOTICE}.date_of_applicant`,
                                    value
                                  );
                                }}
                                onSelect={(value) => {
                                  setFieldValue(
                                    `my_documents_inputs.${SelfDocuments.PRIOR_NOTICE}.date_of_applicant`,
                                    value
                                  );
                                }}
                              />
                              <ErrorMessage
                                name={`my_documents_inputs.${SelfDocuments.PRIOR_NOTICE}.date_of_applicant`}
                                component="div"
                                className="text-danger"
                              />
                            </div>
                          </div>
                        )}

                        {document.slug === SelfDocuments.FORM_AI && (
                          <div className="row g-3 m-0">
                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                              <label
                                htmlFor={`my_documents_inputs.${SelfDocuments.FORM_AI}.place_of_issue`}
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Place Of Issue
                              </label>
                              <Field
                                name={`my_documents_inputs.${SelfDocuments.FORM_AI}.place_of_issue`}
                                type="text"
                                className="form-control"
                                placeholder="Enter Place Of Issue"
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name={`my_documents_inputs.${SelfDocuments.FORM_AI}.place_of_issue`}
                                component="div"
                                className="text-danger"
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                              <label
                                htmlFor={`my_documents_inputs.${SelfDocuments.FORM_AI}.reference_no`}
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Reference No.
                              </label>
                              <Field
                                name={`my_documents_inputs.${SelfDocuments.FORM_AI}.reference_no`}
                                type="text"
                                className="form-control"
                                placeholder="Enter Reference No."
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name={`my_documents_inputs.${SelfDocuments.FORM_AI}.reference_no`}
                                component="div"
                                className="text-danger"
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                              <label
                                htmlFor={`my_documents_inputs.${SelfDocuments.FORM_AI}.port_of_discharge`}
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Port Of Discharge
                              </label>
                              <Field
                                name={`my_documents_inputs.${SelfDocuments.FORM_AI}.port_of_discharge`}
                                type="text"
                                className="form-control"
                                placeholder="Enter Port Of Discharge"
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name={`my_documents_inputs.${SelfDocuments.FORM_AI}.port_of_discharge`}
                                component="div"
                                className="text-danger"
                              />
                            </div>
                          </div>
                        )}

                        {document.slug ===
                          SelfDocuments.FUMIGATION_CERTIFICATE && (
                          <div className="row g-3 m-0">
                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                              <label
                                htmlFor={`my_documents_inputs.${SelfDocuments.FUMIGATION_CERTIFICATE}.date`}
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Date
                              </label>
                              <DatePicker
                                id={`my_documents_inputs.${SelfDocuments.FUMIGATION_CERTIFICATE}.date`}
                                name={`my_documents_inputs.${SelfDocuments.FUMIGATION_CERTIFICATE}.date`}
                                format="dd-MM-yyyy"
                                className="form-control"
                                placeholder="Select Date"
                                value={parseDateOrNull(
                                  values?.my_documents_inputs?.[
                                    SelfDocuments.FUMIGATION_CERTIFICATE
                                  ]?.date
                                )}
                                onChange={(value: any) => {
                                  setFieldValue(
                                    `my_documents_inputs.${SelfDocuments.FUMIGATION_CERTIFICATE}.date`,
                                    value || null
                                  );
                                }}
                                onSelect={(value) => {
                                  setFieldValue(
                                    `my_documents_inputs.${SelfDocuments.FUMIGATION_CERTIFICATE}.date`,
                                    value || null
                                  );
                                }}
                              />
                              <ErrorMessage
                                name={`my_documents_inputs.${SelfDocuments.FUMIGATION_CERTIFICATE}.date`}
                                component="div"
                                className="text-danger"
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                              <label
                                htmlFor={`my_documents_inputs.${SelfDocuments.FUMIGATION_CERTIFICATE}.registration_no`}
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Registration No.
                              </label>
                              <Field
                                name={`my_documents_inputs.${SelfDocuments.FUMIGATION_CERTIFICATE}.registration_no`}
                                type="text"
                                className="form-control"
                                placeholder="Enter Registration No."
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name={`my_documents_inputs.${SelfDocuments.FUMIGATION_CERTIFICATE}.registration_no`}
                                component="div"
                                className="text-danger"
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                              <label
                                htmlFor={`my_documents_inputs.${SelfDocuments.FUMIGATION_CERTIFICATE}.treatment_certificate_no`}
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Treatment Certificate No.
                              </label>
                              <Field
                                name={`my_documents_inputs.${SelfDocuments.FUMIGATION_CERTIFICATE}.treatment_certificate_no`}
                                type="text"
                                className="form-control"
                                placeholder="Enter Treatment Certificate No."
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name={`my_documents_inputs.${SelfDocuments.FUMIGATION_CERTIFICATE}.treatment_certificate_no`}
                                component="div"
                                className="text-danger"
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                              <label
                                htmlFor={`my_documents_inputs.${SelfDocuments.FUMIGATION_CERTIFICATE}.place_of_fumigation`}
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Place Of Fumigation
                              </label>
                              <Field
                                name={`my_documents_inputs.${SelfDocuments.FUMIGATION_CERTIFICATE}.place_of_fumigation`}
                                type="text"
                                className="form-control"
                                placeholder="Enter Place Of Fumigation"
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name={`my_documents_inputs.${SelfDocuments.FUMIGATION_CERTIFICATE}.place_of_fumigation`}
                                component="div"
                                className="text-danger"
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                              <label
                                htmlFor={`my_documents_inputs.${SelfDocuments.FUMIGATION_CERTIFICATE}.destination_port_country`}
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Destination Port Country
                              </label>
                              <Field
                                name={`my_documents_inputs.${SelfDocuments.FUMIGATION_CERTIFICATE}.destination_port_country`}
                                type="text"
                                className="form-control"
                                placeholder="Enter Destination Port Country"
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name={`my_documents_inputs.${SelfDocuments.FUMIGATION_CERTIFICATE}.destination_port_country`}
                                component="div"
                                className="text-danger"
                              />
                            </div>
                          </div>
                        )}

                        {document.slug === SelfDocuments.ANNEXURE_C && (
                          <div className="row g-3 m-0">
                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                              <label
                                htmlFor={`my_documents_inputs.${SelfDocuments.ANNEXURE_C}.factory_address`}
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Factory Address
                              </label>
                              <Field
                                name={`my_documents_inputs.${SelfDocuments.ANNEXURE_C}.factory_address`}
                                type="text"
                                className="form-control"
                                placeholder="Enter Factory Address"
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name={`my_documents_inputs.${SelfDocuments.ANNEXURE_C}.factory_address`}
                                component="div"
                                className="text-danger"
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                              <label
                                htmlFor={`my_documents_inputs.${SelfDocuments.ANNEXURE_C}.date_of_examination`}
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Date Of Examination
                              </label>
                              <DatePicker
                                id={`my_documents_inputs.${SelfDocuments.ANNEXURE_C}.date_of_examination`}
                                name={`my_documents_inputs.${SelfDocuments.ANNEXURE_C}.date_of_examination`}
                                format="dd-MM-yyyy"
                                className="form-control"
                                placeholder="Select Date Of Examination"
                                value={parseDateOrNull(
                                  values?.my_documents_inputs?.[
                                    SelfDocuments.ANNEXURE_C
                                  ]?.date_of_examination
                                )}
                                onChange={(value: any) => {
                                  setFieldValue(
                                    `my_documents_inputs.${SelfDocuments.ANNEXURE_C}.date_of_examination`,
                                    value
                                  );
                                }}
                                onSelect={(value) => {
                                  setFieldValue(
                                    `my_documents_inputs.${SelfDocuments.ANNEXURE_C}.date_of_examination`,
                                    value
                                  );
                                }}
                              />
                              <ErrorMessage
                                name={`my_documents_inputs.${SelfDocuments.ANNEXURE_C}.date_of_examination`}
                                component="div"
                                className="text-danger"
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                              <label
                                htmlFor={`my_documents_inputs.${SelfDocuments.ANNEXURE_C}.date_of_sealing`}
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Date Of Sealing
                              </label>
                              <DatePicker
                                id={`my_documents_inputs.${SelfDocuments.ANNEXURE_C}.date_of_sealing`}
                                name={`my_documents_inputs.${SelfDocuments.ANNEXURE_C}.date_of_sealing`}
                                format="dd-MM-yyyy"
                                className="form-control"
                                placeholder="Select Date Of Sealing"
                                value={parseDateOrNull(
                                  values?.my_documents_inputs?.[
                                    SelfDocuments.ANNEXURE_C
                                  ]?.date_of_sealing
                                )}
                                onChange={(value: any) => {
                                  setFieldValue(
                                    `my_documents_inputs.${SelfDocuments.ANNEXURE_C}.date_of_sealing`,
                                    value
                                  );
                                }}
                                onSelect={(value) => {
                                  setFieldValue(
                                    `my_documents_inputs.${SelfDocuments.ANNEXURE_C}.date_of_sealing`,
                                    value
                                  );
                                }}
                              />
                              <ErrorMessage
                                name={`my_documents_inputs.${SelfDocuments.ANNEXURE_C}.date_of_sealing`}
                                component="div"
                                className="text-danger"
                              />
                            </div>
                          </div>
                        )}

                        {document.slug === SelfDocuments.BILL_OF_LADING && (
                          <div className="row g-3 m-0">
                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                              <label
                                htmlFor={`my_documents_inputs.${SelfDocuments.BILL_OF_LADING}.booking_no`}
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Booking No
                              </label>
                              <Field
                                name={`my_documents_inputs.${SelfDocuments.BILL_OF_LADING}.booking_no`}
                                type="text"
                                className="form-control"
                                placeholder="Enter Booking No"
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name={`my_documents_inputs.${SelfDocuments.BILL_OF_LADING}.booking_no`}
                                component="div"
                                className="text-danger"
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                              <label
                                htmlFor={`my_documents_inputs.${SelfDocuments.BILL_OF_LADING}.line`}
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Line
                              </label>
                              <Field
                                name={`my_documents_inputs.${SelfDocuments.BILL_OF_LADING}.line`}
                                type="text"
                                className="form-control"
                                placeholder="Enter Line"
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name={`my_documents_inputs.${SelfDocuments.BILL_OF_LADING}.line`}
                                component="div"
                                className="text-danger"
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                              <label
                                htmlFor={`my_documents_inputs.${SelfDocuments.BILL_OF_LADING}.sb_no`}
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Sb No.
                              </label>
                              <Field
                                name={`my_documents_inputs.${SelfDocuments.BILL_OF_LADING}.sb_no`}
                                type="text"
                                className="form-control"
                                placeholder="Enter Sb No."
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name={`my_documents_inputs.${SelfDocuments.BILL_OF_LADING}.sb_no`}
                                component="div"
                                className="text-danger"
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                              <label
                                htmlFor={`my_documents_inputs.${SelfDocuments.BILL_OF_LADING}.sb_date`}
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Sb Date
                              </label>
                              <DatePicker
                                id={`my_documents_inputs.${SelfDocuments.BILL_OF_LADING}.sb_date`}
                                name={`my_documents_inputs.${SelfDocuments.BILL_OF_LADING}.sb_date`}
                                format="dd-MM-yyyy"
                                className="form-control"
                                placeholder="Select Sb Date"
                                value={parseDateOrNull(
                                  values?.my_documents_inputs?.[
                                    SelfDocuments.BILL_OF_LADING
                                  ]?.sb_date
                                )}
                                onChange={(value: any) => {
                                  setFieldValue(
                                    `my_documents_inputs.${SelfDocuments.BILL_OF_LADING}.sb_date`,
                                    value
                                  );
                                }}
                                onSelect={(value) => {
                                  setFieldValue(
                                    `my_documents_inputs.${SelfDocuments.BILL_OF_LADING}.sb_date`,
                                    value
                                  );
                                }}
                              />
                              <ErrorMessage
                                name={`my_documents_inputs.${SelfDocuments.BILL_OF_LADING}.sb_date`}
                                component="div"
                                className="text-danger"
                              />
                            </div>
                          </div>
                        )}

                        {document.slug === SelfDocuments.COMMERCIAL_INVOICE && (
                          <div className="row g-3 m-0">
                            <div className="col-12">
                              <div className="form-check m-0 mt-5">
                                <Field
                                  type="checkbox"
                                  id={`my_documents_inputs.${SelfDocuments.COMMERCIAL_INVOICE}.show_total_fields`}
                                  name={`my_documents_inputs.${SelfDocuments.COMMERCIAL_INVOICE}.show_total_fields`}
                                  checked={
                                    values.my_documents_inputs?.[
                                      SelfDocuments.COMMERCIAL_INVOICE
                                    ]?.show_total_fields
                                  }
                                  onChange={(e: any) => {
                                    handleChange(e);
                                  }}
                                  className="form-check-input"
                                />
                                <label
                                  htmlFor={`my_documents_inputs.${SelfDocuments.COMMERCIAL_INVOICE}.show_total_fields`}
                                  className="form-label"
                                  style={{ fontSize: "0.9375rem" }}
                                >
                                  Show Total Fields
                                </label>
                              </div>
                            </div>
                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                              <label
                                htmlFor={`my_documents_inputs.${SelfDocuments.COMMERCIAL_INVOICE}.freight`}
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Freight
                              </label>
                              <Field
                                name={`my_documents_inputs.${SelfDocuments.COMMERCIAL_INVOICE}.freight`}
                                type="number"
                                className="form-control"
                                placeholder="Enter Freight"
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name={`my_documents_inputs.${SelfDocuments.COMMERCIAL_INVOICE}.freight`}
                                component="div"
                                className="text-danger"
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                              <label
                                htmlFor={`my_documents_inputs.${SelfDocuments.COMMERCIAL_INVOICE}.insurance`}
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Insurance
                              </label>
                              <Field
                                name={`my_documents_inputs.${SelfDocuments.COMMERCIAL_INVOICE}.insurance`}
                                type="number"
                                className="form-control"
                                placeholder="Enter Insurance"
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name={`my_documents_inputs.${SelfDocuments.COMMERCIAL_INVOICE}.insurance`}
                                component="div"
                                className="text-danger"
                              />
                            </div>
                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                              <label
                                htmlFor={`my_documents_inputs.${SelfDocuments.COMMERCIAL_INVOICE}.discount`}
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Discount
                              </label>
                              <Field
                                name={`my_documents_inputs.${SelfDocuments.COMMERCIAL_INVOICE}.discount`}
                                type="number"
                                className="form-control"
                                placeholder="Enter Discount"
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name={`my_documents_inputs.${SelfDocuments.COMMERCIAL_INVOICE}.discount`}
                                component="div"
                                className="text-danger"
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )
                );
              })}
          </div>
        )}
      </div>
    </>
  );
};

export default MyDocumentsFields;
